import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux'
import useAuth from '../../../../features/hooks/useAuth'
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetassetReqQuery, useUpdateassetReqMutation, useUpdateassetReqstatusMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetUsersQuery, useAddUserAssetsMutation } from '../../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetAssetsFinalQuery, useUpdateAddAssetFinalMutation, useUpdateAssetintransitMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import Select from 'react-select';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import { useAddNewassetTransMutation, useGetassetTransQuery, useUpdateassetTransMutation, } from '../../../../features/assetTransApiSlice/assetTransApiSlice'
import EnhancedTable from './StoreAssetTransSentTable'
import ReactTooltip from "react-tooltip";
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, AddRemarkButton, BackButtonSpan, StoreNameCont, ExtReqWrapper, PopupButton } from '../../../../Styles/CommonStyles'

const Container = styled.div``
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`
const ReqWrapper = styled.div``

const TextWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`
const PreDataCont = styled.div`
`
const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`

const StoreAssetTransReqSentForm = ({ reqid, setChangepage }) => {

  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]

  //Single Request call
  const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
    selectFromResult: ({ data }) => ({
      getSingleRequest: data?.entities
    }),
  })

  // call the req doc which is clicked
  let singleReq_data = getSingleRequest && getSingleRequest[reqid]

  // call the req doc which is clicked
  let lastIndex = singleReq_data?.req_data?.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]))
  let splicedArray = singleReq_data.req_data?.slice(0, lastIndex + 1)

  return (
    <Container>
       <BackArrowContainer onClick={() => setChangepage([true, false, false, false, false])}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
      <Wrapper>
        <ReqWrapper>
            <PreDataCont>
              {splicedArray?.map((elm, ind) =>
                <PreDataWrap key={ind}>
                  <HeadingWrap>
                  <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                  </HeadingWrap>
                  {elm.assets_details && <Span>Requested Asset Details (selected in the checkbox):</Span>}
                  {elm.assets_details && <EnhancedTable intSelectedAssets={elm.assets_details}/>}
                  <TextWrapper>
                    Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                  </TextWrapper>
                  <TimeAndNameCont>
                    <TimeWrapper>
                      {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                    </TimeWrapper>
                    <UserNameContainer>
                      {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                    </UserNameContainer>
                  </TimeAndNameCont>
                </PreDataWrap>)}
            </PreDataCont>
        </ReqWrapper>
      </Wrapper>
    </Container>
  )
}

export default StoreAssetTransReqSentForm